import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <div className="flex-1 container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="text-4xl font-black text-gray-900 mb-8 font-kannada">Terms of Service (ಸೇವಾ ನಿಯಮಗಳು)</h1>
        
        <div className="space-y-8 text-gray-600 font-medium leading-relaxed">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">1. Acceptance of Terms</h2>
            <p>By accessing the digital e-paper of **Kallina Koogu**, you agree to abide by these terms. This website is provided as a service to the readers of Chitradurga District.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">2. Intellectual Property</h2>
            <p>All content, including news articles, photographs, and the PDF layout of the newspaper, is the property of **Kallina Koogu**. You may not reproduce, redistribute, or sell this content without written permission from the Chief Editor, **Prakashmurthy S**.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">3. Personal Use Only</h2>
            <p>The e-paper is provided for your personal, non-commercial reading. You are encouraged to share the website link with friends and family via social media, but you may not host our PDF files on other servers.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3">4. Limitation of Liability</h2>
            <p>While we strive for 100% accuracy in our reporting, **Kallina Koogu** is not liable for any errors or omissions in the news content. We are also not responsible for the content of external advertisements displayed on this site.</p>
          </section>

          <section className="bg-gray-50 p-6 rounded-2xl border border-gray-100">
            <h2 className="text-xl font-bold text-gray-900 mb-3">5. Contact Information</h2>
            <p className="font-kannada">ಯಾವುದೇ ಪ್ರಶ್ನೆಗಳಿದ್ದಲ್ಲಿ ನಮ್ಮನ್ನು ಸಂಪರ್ಕಿಸಿ:</p>
            <p className="mt-2 text-sm">
              <strong>Kallina Koogu Office</strong><br />
              Shivalingappa Layout, Hosadurga,<br />
              Chitradurga - 577527<br />
              Phone: +91 7019362261
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;
